export default __webpack_public_path__ + "static/media/watchtower.3e4cd30f.svg";